<template>
	<div>
		<div class="jdbn">
			<img style="width: 100%; height: 100%" src="../../assets/base/2jd/2页头-3X-1440-160.png" />
		</div>
		<div class="amap-wrapper">
			<el-amap class="amap-box" :vid="'amap-vue'" :center="center" :zoom="zoom">
				<!--marker-->
				<el-amap-marker v-for="(marker, index) in markers" :key="'marker' + index" :position="marker"
					:label="label">
				</el-amap-marker>
			</el-amap>
		</div>
		<main>
			<div class="main-banner">
				<img src="../../assets/base/banner1-3X-1301_118.png" />
			</div>
			<div class="main-baseintur">
				<img src="../../assets/base/2jd/2基地介绍-3X-1440-690.png" />
				<!--           <p>
                二基地重庆君道金属材料有限公司，隶属于重庆君道物流有限公司，位于江北区鱼嘴镇，成立于2020年10月20日，占地8亩，南边紧靠重庆铁路货运鱼嘴站，西南方临近重庆果园港码头；具有原料到达物流成本低的优势。

            </p> -->
			</div>
			<div class="main-service">
				<img src="../../assets/base/2jd/2星级服务-3X-1440-820.png" alt="" />
			</div>
			<div class="main-cut" v-if="0">
				<img src="../../assets/base/剪切机组-1X-1580_200.png" />
			</div>
			<div class="Shear_unit">
				<el-carousel :interval="3000" class="h530">
					<el-carousel-item class="h530">
						<div class="mybox"
							:style="{backgroundImage: 'url('+require('../../assets/base/2jd/1250横切机组-3X-1440_1122.png')+')'}">
						</div>
					</el-carousel-item>
					<el-carousel-item class="h530">
						<div class="mybox"
							:style="{backgroundImage: 'url('+require('../../assets/base/2jd/1500总切机组-3X-1440_1122.png')+')'}">
						</div>
					</el-carousel-item>
					<el-carousel-item class="h530">
						<div class="mybox"
							:style="{backgroundImage: 'url('+require('../../assets/base/2jd/1850横切机组-3X-1440_1122.png')+')'}">
						</div>
					</el-carousel-item>
					<el-carousel-item class="h530">
						<div class="mybox"
							:style="{backgroundImage: 'url('+require('../../assets/base/2jd/1850纵切机组-3X-1440_1122.png')+')'}">
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>
			<div class="main-bottom">
				<img src="../../assets/base/bottom-3X-1580_435.png" alt="" />
			</div>
		</main>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				center: [106.735471, 29.626901],
				zoom: 13,
				markers: [],
				radius: 10,
				label: {
					content: "二基地·重庆君道金属材料有限公司——(重庆市江北区长美路103号3号厂房)",
					offset: [10, 12],
				},
			};
		},
		mounted() {
			this.markers.push([106.735471, 29.626901]);
		},
	};
</script>
<style lang="less" scoped>
	.amap-wrapper {
		width: 100%;
		height: 300px;
	}

	.jdbn {
		margin-bottom: 4px;
		width: 100%;
	}

	main {
		.main-banner {
			padding: 40px 27px 70px 0;
			width: 100%;
			background: rgb(20, 157, 214);
			box-sizing: border-box;

			img {
				width: 90%;
				margin-left: 5%;
			}
		}

		.main-baseintur {
			width: 100%;
			position: relative;
			background-color: #149DD6;

			img {
				width: 100%;
			}

			p {
				width: 45%;
				position: absolute;
				top: 33%;
				left: 35%;
				font-size: 24px;
				line-height: 40px;
				color: #ffffff;
			}
		}

		.main-service {
			width: 100%;
			position: relative;
			background-color: #149DD6;

			img {
				width: 100%;
			}

			.service-content {
				width: 80%;
				position: absolute;
				top: 25%;
				left: 20%;
				transform: translateX(-20%);
			}
		}

		.main-cut {
			width: 100%;
			margin-top: 40px;
			position: relative;

			img {
				width: 100%;
			}

			.cut-content {
				width: 100%;
				position: absolute;
				top: 25%;
				left: 0;

				.swiper-wrapper {
					margin-left: 10%;
				}

				.swiper-slide {
					img {
						width: 80%;
					}
				}

				.base3-wrapper {
					margin-left: 25%;
				}

				.base3-slide {
					img {
						width: 50%;
					}
				}

				.swiper-button-prev {
					width: 60px;
					height: 60px;
				}

				.swiper-button-next {
					width: 60px;
					height: 60px;
				}
			}
		}

		.main-bottom {
			width: 100%;
			background-image: linear-gradient(180deg, #19a7df 0%, #0881ba 100%);

			img {
				width: 100%;
			}
		}
	}

.mybox{
    width:100%;
	height:100%;
    padding-top:80px;
    background-size:100% 100%;
    background-repeat: no-repeat;

}
.h530{
	overflow-y: auto;
	min-height: 1000px;
	background-color: #149DD6;
}
</style>